/**
 * 成员删除
 */
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IDeleteMemberInput {
    member_ids: string;
}
export interface IDeleteMemberOutput {
    status: number;
    desc: string;
}
export const batchDeleteMember = (data: IDeleteMemberInput) => {
    return fetchData(Api.BATCH_DELETE_MEMBER, data).then((res: IResponse<IDeleteMemberOutput>) => {
        return res.data;
    });
};
